module.exports = __webpack_public_path__ + "img/xinghao2.8fe2d1d5.png";